import styled from 'styled-components';
import { RED, BLUE, STATS, HIGLIGHT_COLOR } from '../../constants';

const StyledLi = styled.li`
  background-color: #999;
  margin: 6px;
  padding: 0;
  padding-top: 3px;
  padding-left: 3px;
  border: 8px inset #aaa;
  height: 115px;
  width: 112px;
  position: relative;
`;

export const BoardGridDot = styled(StyledLi)`
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: '';
    border-radius: 50%;
    width: 25px;
    height: 25px;
    background-color: ${({dot}) =>
      dot === RED ? STATS[RED].hexColor : STATS[BLUE].hexColor};
  }
`;

const GridSquare = ({ className, dot = false, highlight, children }) => {
  return !dot ? (
    <StyledLi
      className={className}
      style={{ borderColor: highlight && HIGLIGHT_COLOR }}
    >
      {children}
    </StyledLi>
  ) : (
    <BoardGridDot
      className={className}
      dot={dot}
      style={{ borderColor: highlight && HIGLIGHT_COLOR }}
    >
      {children}
    </BoardGridDot>
  );
};

export default GridSquare;
